<dx-form
  *ngIf="adresKontrolTuru; else loading"
  class="read-only-style"
  [labelMode]="labelMode"
  [labelLocation]="labelLocation"
  [readOnly]="readOnly"
>
  <!-- ADRES BILGI SISTEMI -->
  <dxi-item *ngIf="adresKontrolTuru == 'A'" itemType="group">
    <dxi-item
      *ngIf="showParselKod"
      [label]="{ text: 'Parsel Kod' }"
      [validationRules]="parselKodValidationRules"
    >
      <div *dxTemplate>
        <dk-ctl-gen-kontrol
          [controlName]="'AksParsel'"
          [labelText]="'Parsel Kod'"
          [labelMode]="labelMode"
          [type]="'number'"
          [code]="parselKod"
          (dataResult)="parselKodControlResult($event)"
          [isReadOnly]="readOnly"
          [validationRulesMap]="parselKodValidationRules"
        ></dk-ctl-gen-kontrol>
      </div>
    </dxi-item>

    <dxi-item
      *ngIf="showAda"
      cssClass="mw-15ch"
      [label]="{ text: 'Ada' }"
      editorType="dxNumberBox"
      [editorOptions]="{
        value: ada,
        onValueChanged: onAdaValueChanged,
        readOnly: true
      }"
    ></dxi-item>
    <dxi-item
      *ngIf="showPafta"
      cssClass="mw-15ch"
      [label]="{ text: 'Pafta' }"
      editorType="dxTextBox"
      [editorOptions]="{
        value: pafta,
        onValueChanged: onPaftaValueChanged,
        readOnly: true
      }"
    ></dxi-item>
    <dxi-item
      *ngIf="showParsel"
      cssClass="mw-20ch"
      [label]="{ text: 'Parsel' }"
      editorType="dxNumberBox"
      [editorOptions]="{
        value: parsel,
        onValueChanged: onParselValueChanged,
        readOnly: true,
        buttons: [
          {
            name: 'mapButton',
            location: 'after',
            options: mapParselButtonOptions
          }
        ]
      }"
    ></dxi-item>
    <dxi-item
      *ngIf="showBinaKod"
      cssClass="mw-20ch"
      [label]="{ text: 'Bina Kod' }"
      editorType="dxNumberBox"
      [editorOptions]="{
        value: binaKod,
        onValueChanged: onBinaKodValueChanged,
        readOnly: true,
        buttons: [
          {
            name: 'mapButton',
            location: 'after',
            options: mapBinaKodButtonOptions
          }
        ]
      }"
    ></dxi-item>
  </dxi-item>

  <!-- SERBEST GIRIS -->
  <dxi-item *ngIf="adresKontrolTuru == 'Y'" itemType="group">
    <dxi-item
      *ngIf="showParselKod"
      cssClass="mw-15ch"
      [label]="{ text: 'Parsel Kod' }"
      editorType="dxNumberBox"
      [editorOptions]="{
        value: parselKod,
        onValueChanged: onParselKodValueChanged,
        readOnly: readOnly
      }"
    ></dxi-item>
    <dxi-item
      *ngIf="showAda"
      cssClass="mw-15ch"
      [label]="{ text: 'Ada' }"
      editorType="dxNumberBox"
      [editorOptions]="{
        value: ada,
        onValueChanged: onAdaValueChanged,
        readOnly: readOnly
      }"
    ></dxi-item>
    <dxi-item
      *ngIf="showPafta"
      cssClass="mw-15ch"
      [label]="{ text: 'Pafta' }"
      editorType="dxTextBox"
      [editorOptions]="{
        value: pafta,
        onValueChanged: onPaftaValueChanged,
        readOnly: readOnly
      }"
    ></dxi-item>
    <dxi-item
      *ngIf="showParsel"
      cssClass="mw-20ch"
      [label]="{ text: 'Parsel' }"
      editorType="dxNumberBox"
      [editorOptions]="{
        value: parsel,
        onValueChanged: onParselValueChanged,
        readOnly: readOnly,
        buttons: [
          {
            name: 'mapButton',
            location: 'after',
            options: mapParselButtonOptions
          }
        ]
      }"
    ></dxi-item>

    <dxi-item
      *ngIf="showBinaKod"
      cssClass="mw-20ch"
      [label]="{ text: 'Bina Kod' }"
      editorType="dxNumberBox"
      [editorOptions]="{
        value: binaKod,
        onValueChanged: onBinaKodValueChanged,
        readOnly: readOnly,
        buttons: [
          {
            name: 'mapButton',
            location: 'after',
            options: mapBinaKodButtonOptions
          }
        ]
      }"
    ></dxi-item>
  </dxi-item>

    <!-- UAVT -->
    <dxi-item *ngIf="adresKontrolTuru == 'U'" itemType="group">
            <dxi-item
      *ngIf="showParselKod"
      cssClass="mw-15ch"
      [label]="{ text: 'Parsel Kod' }"
      editorType="dxNumberBox"
      [editorOptions]="{
        value: parselKod,
        onValueChanged: onParselKodValueChanged,
        readOnly: true
      }"
    ></dxi-item>
    <dxi-item
      *ngIf="showAda"
      cssClass="mw-15ch"
      [label]="{ text: 'Ada' }"
      editorType="dxNumberBox"
      [editorOptions]="{
        value: ada,
        onValueChanged: onAdaValueChanged,
        readOnly: true
      }"
    ></dxi-item>
    <dxi-item
      *ngIf="showPafta"
      cssClass="mw-15ch"
      [label]="{ text: 'Pafta' }"
      editorType="dxTextBox"
      [editorOptions]="{
        value: pafta,
        onValueChanged: onPaftaValueChanged,
        readOnly: true
      }"
    ></dxi-item>
    <dxi-item
      *ngIf="showParsel"
      cssClass="mw-20ch"
      [label]="{ text: 'Parsel' }"
      editorType="dxNumberBox"
      [editorOptions]="{
        value: parsel,
        onValueChanged: onParselValueChanged,
        readOnly: true,
        buttons: [
          {
            name: 'mapButton',
            location: 'after',
            options: mapParselButtonOptions
          }
        ]
      }"
    ></dxi-item>

    <dxi-item
      *ngIf="showBinaKod"
      cssClass="mw-20ch"
      [label]="{ text: 'Bina Kod' }"
      editorType="dxNumberBox"
      [editorOptions]="{
        value: binaKod,
        onValueChanged: onBinaKodValueChanged,
        readOnly: true,
        buttons: [
          {
            name: 'mapButton',
            location: 'after',
            options: mapBinaKodButtonOptions
          }
        ]
      }"
    ></dxi-item>

    </dxi-item>
</dx-form>

<ng-template #loading>
  <h1>Adres Parametreleri Yükleniyor ..</h1>
</ng-template>

<dk-form-popup
  *ngIf="showMapPopup"
  width="70%"
  height="80%"
  [title]="'Harita'"
  [(visible)]="showMapPopup"
  [popupName]="'Harita'"
  [state]="'View'"
>
  <dk-gis-map
    style="display:inline-block;height: 98%"
    [text]="mapText"
    [value]="mapValue"
  >
  </dk-gis-map>
</dk-form-popup>
